import React, { ReactNode, useEffect } from 'react';
import { connect } from 'dva';
import { Header } from '@/components';
import { BackTop } from 'antd';
import { isMobile } from '@/utils/tool';
import backImg from '@/assets/image/back.png';
import styles from './app.less';

interface IAppProps {
  children: ReactNode;
}

const App: React.FC<IAppProps> = ({ children }) => {
  
  useEffect(()=>{
    if (!isMobile()) { 
      window.location.href = 'http://competition.gjwlaqxcz.cn/'
    }
  },[])

  return (
    <div className={styles.layout}>
      <Header />
      <div className={styles.content}>
        {children}
      </div>
      <BackTop visibilityHeight={800}>
        <img src={backImg} alt="" width="54" height="54" />
      </BackTop>
      {/* <Footer /> */}
      {/* <div className={styles.presented}>
        <div className={styles.text}>
          版权所有© 国家工业信息安全发展研究中心
        </div>
        <div className={styles.text}>
          ICP备案编号：京ICP备05037055号
        </div>
      </div> */}
    </div>
  );
};


export default connect()(App);
